import React, {useState, useEffect} from 'react';
import {Col} from 'reactstrap';
import CountdownNow from 'react-countdown-now';
import Cookies from "js-cookie";
import classes from './Countdown.module.scss';
import {usePhases} from '../../../shared/config';

const Countdown = () => {
    const votingPhases = usePhases();
    const [animate, setAnimate] = useState(false);
    const [animateMessage] = useState('Jetzt mit SMS-Code abstimmen!');
    let daysInHours;

    useEffect(() => {
        if (Cookies.get('bigfoot_code-requested') && !animate) {
            setAnimate(true);
        } else if (!Cookies.get('bigfoot_code-requested') && animate) {
            setAnimate(false);
        }
    }, [animate]);

    let phaseDate = '';
    let countdownMessage = '';
    if (votingPhases && Object.keys(votingPhases).length !== 0) {
        phaseDate = votingPhases.phaseDate;
        countdownMessage = votingPhases.countdownMessage;
    }

    // necessary to render the static string for the accessibleVariant, not animated variant.
    const renderMessageFromDate = ({date, accessibleVariant = false}) => {
        const difference = new Date(new Date(date).toUTCString()) - Date.now();
        const oneSecond = 1000;
        const oneMinute = 60 * oneSecond;
        const oneHour = 60 * oneMinute;
        const oneDay = 24 * oneHour;

        const days = Math.floor(difference / oneDay);
        const hours = Math.floor((difference % oneDay) / oneHour);
        const minutes = Math.floor(((difference % oneDay) % oneHour) / oneMinute);
        const seconds = Math.floor((((difference % oneDay) % oneHour) % oneMinute) / oneSecond);

        return renderMessage({days, hours, minutes, seconds, accessible: accessibleVariant});
    };

    const renderMessage = ({days, hours, minutes, seconds, accessible: accessibleVariant}) => {
        if (!votingPhases.voteEnded) {
            if (days < 2) {
                daysInHours = true;
                return !accessibleVariant ? `Noch ${days} Tag und ${hours}:${minutes}:${seconds + ' ' + countdownMessage}`
                    : `Noch ${days} Tag, ${hours} Stunde${hours > 1 ? "n" : ""}, ${minutes} Minute${minutes > 1 ? "n" : ""} und ${seconds} Sekunde${seconds > 1 ? "n" : ""} ${countdownMessage}`; // until vote start
            } else {
                return `Noch ${days + ' Tage ' + countdownMessage}`;
            }
        } else {
            return "Der Wettbewerb ist beendet";
        }
    };

    const renderer = (props) => <span>{renderMessage(props)}</span>;
    return (
        <Col className={'bg-primary px-0 py-1 text-center text-white'}>
            <div className={animate ? classes.CountdownWrapper : ""}>
                <div className={animate ? `${classes.animatedElement}  ${classes.CountdownTimer}` : ""}
                     aria-hidden={true}>
                    <CountdownNow
                        date={phaseDate}
                        renderer={renderer}
                        daysInHours={daysInHours}
                    />
                </div>
                {animate && <p className={`${classes.animatedElement} ${classes.CountDownMessage}`}
                               aria-hidden={true}>{animateMessage}</p>}
                {<p className="visually-hidden">
                    {renderMessageFromDate({date: phaseDate, accessibleVariant: true})
                        + (animate ? ` - ${animateMessage}` : '')}
                </p>}
            </div>
        </Col>
    );
};

export default Countdown;
